export default __webpack_public_path__ + "static/media/pr{2}B_1_lowdef.3e1a42f6.png";